import styled from "styled-components";
import BigPlayButton from "../../../assets/images/VideoPlayer/bigPlayButton.svg";
import PlayButton from "../../../assets/images/VideoPlayer/play.svg";
import FullSound from "../../../assets/images/VideoPlayer/soundFull.svg";
import HalfSound from "../../../assets/images/VideoPlayer/soundHalf.svg";
import OffSound from "../../../assets/images/VideoPlayer/soundOff.svg";
import FullScreen from "../../../assets/images/VideoPlayer/fullScreen.svg";

export const Styles = styled.div`
  .video-react {
    overflow: hidden;
    border: 1px solid #707070;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    margin-bottom: 20px;
  }

  .video-react-control-bar {
    display: flex;
    background: #fff;
    /* padding-inline-start: 100px; */
    height: 50px;
    color: #707070;
    flex-direction: row-reverse;
  }
  .video-react-control-bar.control-bar-en {
    padding-inline-start: 0;
    padding-inline-end: 100px;
    flex-direction: row;
  }
  .video-react-poster {
    background-size: cover;
  }
  .video-react .video-react-big-play-button {
    margin: 0;
    border: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 180px;
    height: 120px;
    background: transparent;
    border-radius: 35px;
    border: 3px solid #464547;
    transition: 0.3;
    ${(props) => (props.isLoading ? `opacity:0` : `opacity:1`)};
  }

  .video-react-big-play-button::before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: auto;
    content: url(${BigPlayButton});
    ${(props) => (props.isLoading ? `opacity:0` : `opacity:1`)};
  }
  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 120px;
    width: 140px;
    z-index: 10;
    ${(props) => (props.isLoading ? `display:block` : `display:none`)};
  }
  .video-react:hover .video-react-big-play-button {
    border-color: var(--dark-purple);
    box-shadow: 0px 0px 5px var(--light-purple);
  }
  .video-react .video-react-paused,
  .video-react .video-react-playing {
    height: 35px;
    top: 50%;
    transform: translateY(-50%);
    margin-inline-start: 10px;
  }
  .video-react .video-react-paused::before {
    margin-inline-end: 10px;
    width: 40px;
    content: url(${PlayButton});
  }
  .video-react-playing::before {
    font-weight: 900;
    font-size: 30px;
    top: -8px;
    left: 5px;
  }
  .video-react-playback-rate-value {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-end: 20px;
    margin-inline-start: 10px;
  }
  .video-react-playback-rate .video-react-menu {
    transform: translate(-10px, -15px);
  }
  .video-react-menu {
    padding-inline-end: 20px;
    width: 80px !important;
  }
  .video-react-menu-content {
    width: 80px !important;
  }
  .video-react-playback-rate .video-react-menu li {
    background-color: var(--dark-color);
    color: white;
  }
  .video-react-playback-rate .video-react-menu li.video-react-selected {
    background-color: var(--dark-purple);
  }

  .video-react-replay-control::before,
  .video-react-forward-control::before {
    position: relative;
    margin-inline-end: 10px;
    width: 40px;
    font-size: 30px;
  }
  .video-react-volume-menu-button-horizontal {
    height: 30px;
    margin-inline-end: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
  .video-react-vol-3::before {
    width: 40px;
    content: url(${FullSound});
  }
  .video-react-vol-2::before,
  .video-react-vol-1::before {
    width: 40px;
    content: url(${HalfSound}) !important;
  }
  .video-react-vol-0::before,
  .video-react-vol-muted::before {
    content: url(${OffSound}) !important;
  }
  .video-react-icon-fullscreen,
  .video-react-icon-fullscreen-exit {
    height: 35px;
    top: 50%;
    transform: translateY(-50%);
    margin-inline-start: 65px;
  }
  .video-react-control-bar.control-bar-en .video-react-icon-fullscreen,
  .video-react-control-bar.control-bar-en .video-react-icon-fullscreen-exit {
    margin-inline-start: 0;
    margin-inline-end: 65px;
  }
  .video-react-icon-fullscreen::before {
    width: 40px;
    content: url(${FullScreen});
  }
  .video-react-icon-fullscreen-exit::before {
    font-family: "Font Awesome 6 Free";
    font-weight: 900;
    width: 40px;
    content: "\f066";
  }
  .video-react-slider {
    background: #c5c5c5;
  }
  .video-react .video-react-volume-level {
    background: #707070;
  }
  .video-react-current-time-display {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .video-react-time-divider,
  .video-react-duration {
    display: none;
  }
  .video-react-load-progress {
    background: #c5c5c5;
  }
  .video-react-play-progress {
    background: #707070;
  }
  .video-react-play-progress::before {
    font-family: "Font Awesome 6 Free";
    font-weight: 900;
    content: "\f111";
    border-radius: 50%;
  }
  .video-react .video-react-progress-control {
    margin-inline-start: 15px;
  }
  .video-react .share-button {
    position: absolute;
    top: 50%;
    transform: translateY(-55%);
    right: 20px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  .video-react .share-button svg {
    width: 100%;
    height: 100%;
  }
  .video-react.video-react-fullscreen .share-button {
    display: none;
  }
  .video-react.video-react-fullscreen .video-react-icon-fullscreen-exit {
    margin-inline-start: 5px;
  }

  .video-react .trainer-img {
    position: absolute;
    top: -40px;
    right: 15px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #fff;
    background-color: var(--light-purple);
  }
  .video-react .trainer-img img {
    max-width: 100%;
    max-height: 100%;
    padding: 1rem;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    .video-react-control-bar {
      padding-inline-start: 10px;
    }
    .video-react .video-react-big-play-button {
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
    .video-react-big-play-button::before {
      width: 50px;
      height: 40px;
      content: url(${PlayButton});
    }
    .video-react-icon-fullscreen,
    .video-react-icon-fullscreen-exit {
      margin-inline-start: 0;
    }
    .video-react .video-react-progress-control {
      margin-inline-start: 0;
    }
    .video-react .share-button {
      display: none;
    }
    .video-react .trainer-img {
      display: none;
    }
  }
  .video-container {
    width: 100%;
    height: 414px;
    margin-bottom: 20px;
    border-radius: 7px;
    overflow: hidden;
    background: #000;
  }
  .video-container iframe {
    width: 100%;
    height: 100%;
  }
`;
